import { LazyLoadImage } from "react-lazy-load-image-component"
import styled from "styled-components"

import { spacing, Text } from "@minuthq/meatball-ui-react"

import { UpgradeBlockerButton } from "src/components/FeatureBlockers/UpgradeBlockerButton"
import { TPlan } from "src/data/user/user"
import { useTranslate } from "src/i18n/useTranslate"
import IntegrationAnalyticsGraph from "src/ui/images/integration-status.png"
import { MCard } from "src/ui/MCard/MCard"

import "react-lazy-load-image-component/src/effects/opacity.css"

export function IntegrationStatusUpgradeSection({
  requiredPlan,
}: {
  requiredPlan?: TPlan
}) {
  const { t, langKeys } = useTranslate()

  return (
    <StyledMCard padding={spacing.M} boxShadow={false} border={true}>
      <StyledUpgradeSection>
        <IntegrationAnalyticsImage
          src={IntegrationAnalyticsGraph}
          alt={t(langKeys.integrations_title)}
          effect="opacity"
        />

        <UpgradeContent>
          <div>
            <Text variant="heading2">
              {t(langKeys.portfolio_analytics_integrations_status)}
            </Text>
            <Text variant="body" color="secondary">
              {t(
                langKeys.portfolio_analytics_integrations_status_upgrade_description
              )}
            </Text>
          </div>
          <UpgradeBlockerButton
            eventProperties={{
              context: "portfolio_insights",
            }}
            plan={requiredPlan}
          />
        </UpgradeContent>
      </StyledUpgradeSection>
    </StyledMCard>
  )
}

const StyledMCard = styled(MCard)`
  display: grid;
  gap: ${spacing.M};
`

const StyledUpgradeSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.M};
  position: relative;
  justify-content: center;
  align-items: center;
  padding: ${spacing.XL4};
  min-height: 400px;
`

const UpgradeContent = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: ${spacing.L};
  align-items: center;
  text-align: center;
  max-width: 680px;
`

const IntegrationAnalyticsImage = styled(LazyLoadImage)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.2;
`
